interface SkeletonProps {
  className?: string;
  'aria-label'?: string;
}

/**
 * Shape-matching skeleton, not a generic spinner. docs/DESIGN_SYSTEM.md §4.16.
 * Pass a height/width via className (e.g. "h-4 w-32").
 */
export function Skeleton({ className = 'h-4 w-full', ...props }: SkeletonProps) {
  return <div className={['skeleton', className].join(' ')} {...props} />;
}
